/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmailPasswordLoginInfo } from './EmailPasswordLoginInfo';
import {
    EmailPasswordLoginInfoFromJSON,
    EmailPasswordLoginInfoFromJSONTyped,
    EmailPasswordLoginInfoToJSON,
    EmailPasswordLoginInfoToJSONTyped,
} from './EmailPasswordLoginInfo';

/**
 * 
 * @export
 * @interface AuthenticationInfo
 */
export interface AuthenticationInfo {
    /**
     * 
     * @type {EmailPasswordLoginInfo}
     * @memberof AuthenticationInfo
     */
    emailPassword?: EmailPasswordLoginInfo | null;
    /**
     * Normalized to lowercase by the backend.
     * @type {string}
     * @memberof AuthenticationInfo
     */
    nfcToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationInfo
     */
    hardwareKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationInfo
     */
    emailLoginToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationInfo
     */
    pin?: string | null;
}

/**
 * Check if a given object implements the AuthenticationInfo interface.
 */
export function instanceOfAuthenticationInfo(value: object): value is AuthenticationInfo {
    return true;
}

export function AuthenticationInfoFromJSON(json: any): AuthenticationInfo {
    return AuthenticationInfoFromJSONTyped(json, false);
}

export function AuthenticationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'emailPassword': json['emailPassword'] == null ? undefined : EmailPasswordLoginInfoFromJSON(json['emailPassword']),
        'nfcToken': json['nfcToken'] == null ? undefined : json['nfcToken'],
        'hardwareKey': json['hardwareKey'] == null ? undefined : json['hardwareKey'],
        'emailLoginToken': json['emailLoginToken'] == null ? undefined : json['emailLoginToken'],
        'pin': json['pin'] == null ? undefined : json['pin'],
    };
}

export function AuthenticationInfoToJSON(json: any): AuthenticationInfo {
    return AuthenticationInfoToJSONTyped(json, false);
}

export function AuthenticationInfoToJSONTyped(value?: AuthenticationInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailPassword': EmailPasswordLoginInfoToJSON(value['emailPassword']),
        'nfcToken': value['nfcToken'],
        'hardwareKey': value['hardwareKey'],
        'emailLoginToken': value['emailLoginToken'],
        'pin': value['pin'],
    };
}

